// {{domain}}/api/app/orders/{{orderId}}/rate
export const ENDPOINT = (orderId: string) => `api/app/orders/${orderId}/rate`;

// Faixa de valores aceita para a nota do pedido (1 a 5 estrelas).
export const RATING_MIN = 1;
export const RATING_MAX = 5;

// Tamanho máximo do comentário opcional deixado pelo cliente.
export const COMMENT_MAX_LENGTH = 500;

// Resposta pública do estabelecimento a uma avaliação, exibida no detalhe do pedido.
export type MerchantReply = {
  message: string;
  created_at: string;
};

// PRAT-44: motivo de a loja ter ocultado o comentário (a nota continua valendo).
export type CommentHiddenReason = 'offensive' | 'personal_data' | 'spam';

export const COMMENT_HIDDEN_REASON_LABELS: Record<CommentHiddenReason, string> = {
  offensive: 'ofensa ou palavrão',
  personal_data: 'dado pessoal',
  spam: 'spam',
};

// Avaliação persistida de um pedido, retornada pelo backend após a criação.
export type OrderRating = {
  id: string;
  order_id: string;
  rating: number; // nota de 1 a 5 estrelas
  comment: string | null; // comentário opcional do cliente
  created_at: string;
  // Resposta do estabelecimento à avaliação (quando houver).
  merchant_reply?: MerchantReply | null;
  // PRAT-44: comentário ocultado pela loja (opcional para API antiga).
  comment_hidden?: boolean;
  comment_hidden_reason?: CommentHiddenReason | null;
};

// PRAT-111: por onde o cliente chegou à avaliação (vira ratings.source e a taxa por canal).
export type RatingSource =
  'order_page' | 'app_status' | 'banner' | 'push' | 'email' | 'whatsapp';

export const RATING_SOURCES: RatingSource[] = [
  'order_page',
  'app_status',
  'banner',
  'push',
  'email',
  'whatsapp',
];

// Corpo enviado ao backend ao avaliar um pedido finalizado (is_ratable === true).
export type RateOrderBody = {
  rating: number; // nota de 1 a 5 estrelas
  comment?: string; // comentário opcional do cliente
  source?: RatingSource; // canal da avaliação (PRAT-111)
};

// Entrada da usecase: identifica o pedido (via URL) + dados da avaliação.
export type RateOrderRequest = {
  order_id: string;
} & RateOrderBody;

// O backend retorna a avaliação criada, permitindo que a UI atualize o cache
// (ex: esconder o badge "Avalie seu pedido" marcando o pedido como já avaliado).
export type RateOrderResponse = OrderRating;
